import React, { useState } from 'react';
import { Modal, Input, Button, message } from 'antd';
import { BulbOutlined, BugOutlined } from '@ant-design/icons';
import api from '../api/client';

/** Модалка «Предложение» / «Ошибка». Контекст (URL, UA) прикладывается автоматически. */
export default function FeedbackModal({ open, type, onClose }) {
  const isSuggestion = type === 'suggestion';
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!text.trim()) return;
    setSending(true);
    try {
      await api.post('/feedback', {
        type,
        text: text.trim(),
        context: { url: window.location.href, user_agent: navigator.userAgent },
      });
      message.success(isSuggestion ? 'Предложение отправлено' : 'Ошибка отправлена');
      setText('');
      onClose();
    } catch (e) {
      message.error('Не удалось отправить');
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal
      open={open}
      title={isSuggestion ? 'Внести предложение' : 'Сообщить об ошибке'}
      onCancel={() => { setText(''); onClose(); }}
      footer={[
        <Button key="c" onClick={() => { setText(''); onClose(); }}>Отмена</Button>,
        <Button key="s" type="primary" loading={sending} onClick={send}
          icon={isSuggestion ? <BulbOutlined /> : <BugOutlined />}>
          Отправить
        </Button>,
      ]}
    >
      <Input.TextArea
        rows={4}
        value={text}
        onChange={(e) => setText(e.target.value)}
        maxLength={5000}
        placeholder={isSuggestion
          ? 'Что улучшить?'
          : 'Что пошло не так? Что вы делали в этот момент?'}
        autoFocus
      />
    </Modal>
  );
}
